import { type TFunction } from 'i18next'

export const enum PlanId {
	// INTRO = 'intro',
	BASIC = 'basic',
	STANDARD = 'standard',
	PREMIUM = 'premium',
}

export const enum Currency {
	DEFAULT_CURRENCY = 'eur',
	EUR = 'eur',
}

export const PRICING_PLANS = (t: TFunction): PricingPlan => {
	return {
		// [PlanId.INTRO]: {
		// 	id: PlanId.INTRO,
		// 	backendId: 'intro-plan',
		// 	name: t('plans.intro.name'),
		// 	description: t('plans.intro.description'),
		// 	features: [
		// 		t('plans.intro.feature1'),
		// 		t('plans.intro.feature2'),
		// 		t('plans.intro.feature3'),
		// 		t('plans.intro.feature4'),
		// 	],
		// 	limits: { maxItems: 1 },
		// 	prices: {
		// 		[Currency.EUR]: 700,
		// 	},
		// },
		[PlanId.BASIC]: {
			id: PlanId.BASIC,
			backendId: 'basic-plan',
			name: t('plans.basic.name'),
			description: t('plans.basic.description'),
			features: [
				t('plans.basic.feature1'),
				t('plans.basic.feature2'),
				t('plans.basic.feature3'),
				t('plans.basic.feature4'),
			],
			limits: { maxItems: 3 },
			prices: {
				[Currency.EUR]: 1500,
			},
		},
		[PlanId.STANDARD]: {
			id: PlanId.STANDARD,
			backendId: 'standard-plan',
			name: t('plans.standard.name'),
			description: t('plans.standard.description'),
			features: [
				t('plans.standard.feature1'),
				t('plans.standard.feature2'),
				t('plans.standard.feature3'),
				t('plans.standard.feature4'),
			],
			limits: { maxItems: 7 },
			prices: {
				[Currency.EUR]: 2700,
			},
			mostPopular: true,
		},
		[PlanId.PREMIUM]: {
			id: PlanId.PREMIUM,
			backendId: 'premium-plan',
			name: t('plans.premium.name'),
			description: t('plans.premium.description'),
			features: [
				t('plans.premium.feature1'),
				t('plans.premium.feature2'),
				t('plans.premium.feature3'),
				t('plans.premium.feature4'),
			],
			limits: { maxItems: 10 },
			prices: {
				[Currency.EUR]: 4500,
			},
		},
	}
}

type StrapiProductIds =
	| 'intro-plan'
	| 'basic-plan'
	| 'standard-plan'
	| 'premium-plan'

export type PricingPlan = {
	[key in PlanId]: {
		id: PlanId
		name: string
		backendId: StrapiProductIds
		description: string
		features: string[]
		limits: { maxItems: number }
		prices: { [currency in Currency]: number }
		mostPopular?: boolean
	}
}
